import { request } from '@/services/api/requests';
import { ENDPOINTS } from '@/services/endpoints';
import {
  InsuranceBreakdown,
  InsuranceBreakdownParams,
  InsuranceChart,
  InsuranceFilterParams,
  InsuranceContractByPlant,
  InsuranceContractByPlantParams,
  InsuranceContractByRegion,
  InsuranceContractByRegionParams,
  InsuranceStats,
} from '../model';

export const getInsuranceChart = async (params?: InsuranceFilterParams) => {
  const response = await request.get<InsuranceChart>(
    ENDPOINTS.GET_INSURANCE_CHART,
    { params },
  );
  return response.data;
};

export const getInsuranceStats = async (params?: InsuranceFilterParams) => {
  const response = await request.get<InsuranceStats>(
    ENDPOINTS.GET_INSURANCE_STATS,
    { params },
  );
  return response.data;
};

export const getInsuranceStatsBreakdown = async (
  params: InsuranceBreakdownParams,
) => {
  const response = await request.get<InsuranceBreakdown>(
    ENDPOINTS.GET_INSURANCE_STATS_BREAKDOWN,
    { params },
  );
  return response.data;
};

export const getInsuranceContractByPlant = async (
  params?: InsuranceContractByPlantParams,
) => {
  const response = await request.get<InsuranceContractByPlant[]>(
    ENDPOINTS.GET_INSURANCE_CONTRACT_BY_PLANT,
    { params },
  );
  return response.data;
};

export const getInsuranceContractByRegion = async (
  params?: InsuranceContractByRegionParams,
) => {
  const response = await request.get<InsuranceContractByRegion[]>(
    ENDPOINTS.GET_INSURANCE_CONTRACT_BY_REGION,
    { params },
  );
  return response.data;
};
